
import { API, API_GET_ID } from '../../Config'

export const GetSingleVoucher= (id) => {
  return (
    API_GET_ID(API.singlevoucher,id)
  )
}